import { filter, isEmpty, pick, split } from 'lodash'

const transformToUpdateAllergenSimpleDetailsArgs = data => ({
  ...pick(data, [
    'description',
    'isAvailableForDishCategorization',
    'position',
    'isExcludedFromSearch',
  ]),
  synonyms: filter(split(data.synonyms, '\n'), synonym => !isEmpty(synonym)),
})

export default transformToUpdateAllergenSimpleDetailsArgs
